(function () {
    'use strict';

    angular
        .module('appback')
        .factory('OraculusService', OraculusService);

    OraculusService.$inject = ['$http'];

    function OraculusService($http) {

        var service = {
            getIaChat: getIaChat,
            newChatStream: newChatStream,
            setComentarioStream: setComentarioStream
        };

        return service;

        function getIaChat(peticion_id, tipo_pet, ignoreLoadingBar, callback) {
            var config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                },
                ignoreLoadingBar: ignoreLoadingBar,
            }

            $http.get('/backend/oraculus/getiachatbypeticion', { params: { peticion_id: peticion_id, tipo_pet: tipo_pet, ignoreLoadingBar: ignoreLoadingBar }, ignoreLoadingBar: ignoreLoadingBar }, config)
                .then(getContentSuccess, getContentFailed);
            function getContentSuccess(data) {
                callback(data.data);
            }
            function getContentFailed(data) {

                return false;
            }
        }

        function newChatStream(peticiones_relacionadas, idioma_code, onChunk, onComplete, onError, onChatId) {
            var controller = new AbortController();
            var signal = controller.signal;
            var streamController = {
                close: function () {
                    controller.abort();
                }
            };

            var data = $.param({
                peticiones_relacionadas: JSON.stringify(peticiones_relacionadas),
                idioma: idioma_code
            });

            fetch('/backend/oraculus/newchatstream', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                },
                body: data,
                signal: signal
            })
                .then(function (response) {
                    if (!response.ok) throw new Error('Network response was not ok');

                    var reader = response.body.getReader();
                    var decoder = new TextDecoder();
                    var buffer = '';
                    var completed = false;

                    function processStream() {
                        return reader.read().then(function (result) {
                            console.log("result", result);
                            if (result.done) {
                                if (!completed && onComplete) {
                                    completed = true;
                                    onComplete();
                                }
                                return;
                            }

                            // Acumulamos el texto decodificado
                            buffer += decoder.decode(result.value, { stream: true });

                            // Dividimos por saltos de línea dobles (estándar SSE) o simples
                            var lines = buffer.split('\n');

                            // Mantenemos la última línea (posiblemente incompleta) en el buffer
                            buffer = lines.pop();

                            lines.forEach(function (line) {
                                line = line.trim();
                                if (!line || !line.startsWith('data: ')) return;

                                var dataStr = line.substring(6);

                                // Caso fin de stream
                                if (dataStr === '[DONE]') {
                                    if (!completed && onComplete) {
                                        completed = true;
                                        onComplete();
                                    }
                                    return;
                                }

                                try {
                                    var parsedData = JSON.parse(dataStr);

                                    // Chat id recibido
                                    if (parsedData.iachat_id && onChatId) {
                                        onChatId(parsedData.iachat_id);
                                        return; // No procesar como chunk de texto
                                    }

                                    // Si hay error en el JSON del backend
                                    if (parsedData.error) {
                                        if (onError) onError(parsedData.error);
                                        return;
                                    }

                                    // Enviamos el contenido directamente al callback
                                    if (parsedData.content && onChunk) {
                                        onChunk(parsedData.content);
                                    }
                                } catch (e) {
                                    console.warn("Error parseando línea SSE:", dataStr, e);
                                }
                            });

                            if (completed) return;
                            return processStream();
                        });
                    }

                    return processStream();
                })
                .catch(function (error) {
                    if (error.name === 'AbortError') {
                        console.log('Stream abortado por el usuario');
                    } else {
                        if (onError) onError(error.message);
                    }
                });

            return streamController;
        }

        function setComentarioStream(iachat_id, comentario, onChunk, onComplete, onError, onChatId, files) {
            var controller = new AbortController();
            var signal = controller.signal;

            var streamController = {
                close: function () {
                    controller.abort();
                }
            };

            var body;
            var headers = {};

            if (files && files.length > 0) {
                // If there are files, we use FormData
                body = new FormData();
                body.append('iachat_id', iachat_id);
                body.append('comentario', comentario || '');
                for (var i = 0; i < files.length; i++) {
                    body.append('files[]', files[i]);
                }
                // Fetch will automatically set the correct Content-Type with boundary for FormData
            } else {
                // Legacy URL encoded format
                body = $.param({
                    iachat_id: iachat_id,
                    comentario: comentario
                });
                headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8;';
            }

            fetch('/backend/oraculus/setcomentariostream', {
                method: 'POST',
                headers: headers,
                body: body,
                signal: signal
            })
                .then(function (response) {
                    if (!response.ok) throw new Error('Network response was not ok');

                    var reader = response.body.getReader();
                    var decoder = new TextDecoder();
                    var buffer = '';
                    var completed = false;

                    function processStream() {
                        return reader.read().then(function (result) {
                            if (result.done) {
                                if (!completed && onComplete) {
                                    completed = true;
                                    onComplete();
                                }
                                return;
                            }

                            // Acumulamos el texto decodificado
                            buffer += decoder.decode(result.value, { stream: true });

                            // Dividimos por saltos de línea dobles (estándar SSE) o simples
                            var lines = buffer.split('\n');

                            // Mantenemos la última línea (posiblemente incompleta) en el buffer
                            buffer = lines.pop();

                            lines.forEach(function (line) {
                                line = line.trim();
                                if (!line || !line.startsWith('data: ')) return;

                                var dataStr = line.substring(6);

                                // Caso fin de stream
                                if (dataStr === '[DONE]') {
                                    if (!completed && onComplete) {
                                        completed = true;
                                        onComplete();
                                    }
                                    return;
                                }

                                try {
                                    var parsedData = JSON.parse(dataStr);

                                    // Si hay error en el JSON del backend
                                    if (parsedData.error) {
                                        if (onError) onError(parsedData.error);
                                        return;
                                    }

                                    // Enviamos el contenido directamente al callback
                                    if (parsedData.content && onChunk) {
                                        onChunk(parsedData.content);
                                    }
                                } catch (e) {
                                    console.warn("Error parseando línea SSE:", dataStr, e);
                                }
                            });

                            if (completed) return;
                            return processStream();
                        });
                    }

                    return processStream();
                })
                .catch(function (error) {
                    if (error.name === 'AbortError') {
                        console.log('Stream abortado por el usuario');
                    } else {
                        if (onError) onError(error.message);
                    }
                });

            return streamController;
        }
    }
})();